/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Badge_Org_ProvidedInputs */



/**
* | output |
* | --- |
* | "Org-provided" |
*
* @param {My_Integrations_Badge_Org_ProvidedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_badge_org_provided = /** @type {((inputs?: My_Integrations_Badge_Org_ProvidedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Badge_Org_ProvidedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von der Organisation")
	return /** @type {LocalizedString} */ ("Org-provided")
});